import { Badge } from '@liveauctioneers/hammer-ui-core/badge';
import { Broadcast } from '@liveauctioneers/hammer-ui-core/icons';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';

import { CatalogCardProgressBar } from '@/components/CatalogCard/CatalogCardProgressBar';

type Props = {
    catalogId: number;
};

const AutomatedCatalogCarouselCardProgressBar = ({ catalogId }: Props) => {
    const { formatMessage } = useIntl();

    return (
        <div className="flex items-center gap-xs">
            <Badge
                color="critical"
                emphasis="bold"
                iconLeft={Broadcast}
                iconStyle="fill"
                round={false}
                size="xs"
            >
                {formatMessage({
                    id: 'featuredAuctions.live',
                })}
            </Badge>
            <CatalogCardProgressBar catalogId={catalogId} />
        </div>
    );
};

export default AutomatedCatalogCarouselCardProgressBar;
